<script setup lang="ts">
import { computed, toRef } from "vue";
import { Select } from "@/components/episto-ui/select";
import OptionRow from "./OptionRow.vue";
import { useCardLocalOptions } from "@/composables/useCardLocalOptions";

const props = defineProps({
  card: { type: Object, required: true },
  options: { type: Array, default: () => [] },
  defaultValue: { type: String, required: true },
  hint: { type: String, default: "" },
});

const cardRef = toRef(props, "card");
const { localOptions, updateLocalOption } = useCardLocalOptions(cardRef);

const chartType = computed({
  get: () => localOptions.value.chart_type || props.defaultValue,
  set: (val: string) => updateLocalOption("chart_type", val === props.defaultValue ? null : val),
});
</script>

<template>
  <OptionRow
    label="Chart type"
    :hint="hint">
    <Select
      :model-value="chartType"
      :options="options"
      @update:model-value="chartType = $event" />
  </OptionRow>
</template>
